/**
 * Logo monograma de Talenv. Renderiza la "t" en blanco sobre el cuadro
 * violeta + el punto lima a la derecha. Usado en sidebar, login, register,
 * onboarding, checkout, demos, plans y opengraph.
 *
 * Toda actualización del brand mark se hace acá — el resto del producto lo
 * importa y lo escala con la prop `size`.
 */
export function BrandMark({
  size = 32,
  rounded,
  className,
  style,
  ariaLabel = "Talenv",
}: {
  size?: number;
  /** corner-radius en px. Por defecto ~22% del lado (rounded square). */
  rounded?: number;
  className?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
}) {
  const rx = rounded ?? Math.round(size * 0.22);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
      className={className}
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      <defs>
        <linearGradient id="bm-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6B5CFF" />
          <stop offset="100%" stopColor="#3F4FFF" />
        </linearGradient>
        <radialGradient id="bm-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#D4FF5A" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#D4FF5A" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="32" height="32" rx={(rx / size) * 32} fill="url(#bm-bg)" />
      {/* Lowercase "t" — corrida levemente a la izquierda para dejar lugar al punto */}
      <text
        x="13.5"
        y="24"
        textAnchor="middle"
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif"
        fontWeight={800}
        fontSize={22}
        fill="white"
        letterSpacing="-0.04em"
      >
        t
      </text>
      {/* Halo + punto lima */}
      <circle cx="23" cy="22" r="4.5" fill="url(#bm-glow)" />
      <circle cx="23" cy="22" r="2.4" fill="#D4FF5A" />
    </svg>
  );
}
